
import Button from '~/components/detail/Button.vue'
export default {
  components: {
    Button
  },
  props: {
    result: {
      // 交易商数据
      type: Object,
      default: () => {}
    },
    state: {
      // loading-加载状态;success-成功;error-失败；await-等待审核
      type: String,
      default: 'await'
    },
    weburl: {
      type: String,
      default: ''
    },
    wikinum: {
      type: String,
      default: ''
    },
    addtradertype: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      isshow: '1'
    }
  },
  methods: {
    setshow(v) {
      this.isshow = v
    },
    lookcompany() {
      // 重新提交
      this.$emit('lookcompany')
    },
    awaitfn() {
      // 稍后提交
      this.$emit('awaitfn')
    },
    tocompany() {
      // 查看企业
      this.$emit('tocompany')
    },
    tokefufn() {
      // 跳转到人工客服
      console.log(123)
      this.$emit('tokefufn')
    },
    closeawaitfn() {
      // 取消官方验证域名验证
      this.$emit('closeawaitfn')
    },
    aginfn() {
      // 在此验证
      this.$emit('aginfn')
    }
  }
}
